import { useEffect } from "react";
import "./MouseEffects.css";
import { gsap, prefersReducedMotion } from "../../utils/gsap";

const CARD = ".cap-card,.work-card,.proj-card,.cert-card,.contact-card,.experience-card,.deg-card";
const MAGNET = ".btn,.menu-cta,.main-button,.hero-links a";

// Delegated pointer effects: magnetic buttons and 3D tilt with spotlight on cards. Skipped for touch devices and reduced-motion users.
export default function MouseEffects() {
  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (!fine || prefersReducedMotion()) return undefined;

    let card = null;
    let magnet = null;

    const resetCard = (c) => {
      c.classList.remove("is-hover");
      gsap.to(c, {
        rotationX: 0,
        rotationY: 0,
        y: 0,
        duration: 0.7,
        ease: "elastic.out(1, 0.6)",
        overwrite: "auto",
      });
    };
    const resetMagnet = (m) => {
      gsap.to(m, { x: 0, y: 0, duration: 0.7, ease: "elastic.out(1, 0.4)", overwrite: "auto" });
    };

    const onMove = (e) => {
      // tilt + spotlight
      const c = e.target.closest(CARD);
      if (c !== card) {
        if (card) resetCard(card);
        card = c;
        if (card) card.classList.add("is-hover");
      }
      if (card) {
        const r = card.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        card.style.setProperty("--mx", `${px * 100}%`);
        card.style.setProperty("--my", `${py * 100}%`);
        gsap.to(card, {
          rotationY: (px - 0.5) * 10,
          rotationX: (0.5 - py) * 8,
          y: -4,
          transformPerspective: 900,
          duration: 0.4,
          ease: "power2.out",
          overwrite: "auto",
        });
      }

      // magnetic buttons
      const m = e.target.closest(MAGNET);
      if (m !== magnet) {
        if (magnet) resetMagnet(magnet);
        magnet = m;
      }
      if (magnet) {
        const r = magnet.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        gsap.to(magnet, {
          x: dx * 0.25,
          y: dy * 0.35,
          duration: 0.3,
          ease: "power2.out",
          overwrite: "auto",
        });
      }
    };

    const onLeave = () => {
      if (card) resetCard(card);
      if (magnet) resetMagnet(magnet);
      card = magnet = null;
    };

    window.addEventListener("pointermove", onMove, { passive: true });
    document.documentElement.addEventListener("mouseleave", onLeave);
    return () => {
      window.removeEventListener("pointermove", onMove);
      document.documentElement.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  return null;
}
